import { FanLetterItemButtonHeartEvent, FanLetterItemOpenDetailEvent } from '../event/FanLetterItemEvent';
import { debounceWithFirstCall, makeApiUrl } from '../../../../../shared/util';
import axios, { AxiosError } from 'axios';
import { Alert } from '../../Alert/Alert';
import { openFanLetterDetail } from '../../../../pages/CreatorShopFanLetter/util/openFanLetterDetail';
import { FanLetterItemView } from '../FanLetterItemView';

interface FanLetterItemControllerImpl {
  onLike: (e: FanLetterItemButtonHeartEvent) => void;
  onOpenDetail: (e: FanLetterItemOpenDetailEvent) => void;
}

export class FanLetterItemController implements FanLetterItemControllerImpl {
  constructor(public readonly views: FanLetterItemView[]) {
    this.views.forEach((view) => {
      view.addEventListener(FanLetterItemButtonHeartEvent, this.onLike.bind(this));
      view.addEventListener(FanLetterItemOpenDetailEvent, this.onOpenDetail.bind(this));
    });
  }

  public onLike = debounceWithFirstCall((e: FanLetterItemButtonHeartEvent) => {
    const { fan_letter_id, is_like, store_id } = e.detail;
    const post_url = makeApiUrl(`/${ET.lang}/@api/stores/:store_id/like`, { store_id });
    axios
      .post(post_url, {
        is_like,
        attached_id: fan_letter_id,
        attached_type: 'articles',
      })
      .catch((e: Error | AxiosError) => {
        return Alert.open({
          message: (axios.isAxiosError(e) ? (e?.response?.data as string) : e.message) ?? 'API call failed',
        });
      });
  }, 500);

  public async onOpenDetail(e: FanLetterItemOpenDetailEvent) {
    return openFanLetterDetail(e.detail);
  }
}
